var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-details-container"},[_c('Offer',{attrs:{"opportunity":_vm.opportunityInfo}}),_vm._v(" "),(!_vm.authed)?_c('p',{staticClass:"title"},[_vm._v("Log in or register to make an offer...")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }